import React from "react";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Animated } from "react-animated-css";
import translate from "../Translation/i18nProvider/translate";

function HomePage() {
  return (
    <div className="HomePage">
      <header className="hero">
        <h1 className="hero-text">
          <Animated
            animationIn="bounceInDown"
            animationOut="fadeOut"
            isVisible={true}
          >
            {" "}
            {translate("introducing_hello")} <br></br>{" "}
          </Animated>
          <Animated
            animationIn="bounceInDown"
            animationOut="fadeOut"
            isVisible={true}
            animationInDelay={3000}
          >
            {" "}
            <span> {translate("introducing_p2")}</span>{" "}
          </Animated>
        </h1>
        <Animated
          animationIn="bounceIn"
          animationOut="fadeOut"
          isVisible={true}
          animationInDelay={2000}
        >
          <h1 className="hero-text">
            {translate("introducing_im")} <br></br>
            <span> {translate("introducing_name")}</span>
          </h1>
        </Animated>
        <p className="h-sub-text"></p>
        <Animated
          animationIn="bounceIn"
          animationOut="fadeOut"
          isVisible={true}
          animationInDelay={4000}
        >
          <div className="icons">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/Misha.Gubka"
              className="icon-holder"
            >
              <FontAwesomeIcon icon={faFacebook} className="icon fb" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://github.com/MishaHubka1"
              className="icon-holder"
            >
              <FontAwesomeIcon icon={faGithub} className="icon gh" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/channel/UCp8-hgXOKTV-TUPDCnPgr6w"
              className="icon-holder"
            >
              <FontAwesomeIcon icon={faYoutube} className="icon yt" />
            </a>
          </div>
        </Animated>
      </header>
    </div>
  );
}

export default HomePage;
